import React from "react";

const ADO_Intro = () => {
  return (
    <div className="tutorial-page">
      <h1>ADO Intro</h1>
      <p>This is the ADO Intro page content.</p>
    </div>
  );
};

export default ADO_Intro;
